import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const REFRESH_MS = 60000;

// Refetches on window focus and every minute while the tab is visible.
export function useTeamReport(view, params) {
  const [data, setData] = useState(null);
  const key = JSON.stringify(params);
  useEffect(() => {
    let alive = true;
    const load = () => api.get(`/team-report/${view}`, { params: JSON.parse(key) })
      .then((r) => { if (alive) setData(r.data); })
      .catch(() => { if (alive) setData({ rows: [] }); });
    setData(null);
    load();
    const onFocus = () => { if (document.visibilityState === "visible") load(); };
    const t = setInterval(onFocus, REFRESH_MS);
    window.addEventListener("focus", onFocus);
    return () => { alive = false; clearInterval(t); window.removeEventListener("focus", onFocus); };
  }, [view, key]);
  return data;
}
